const fetchUrl = () => process.env.REACT_APP_API_URL;

export default fetchUrl;